module.exports = __webpack_public_path__ + "static/media/not-found-img.d8010b64.svg";